import { render, staticRenderFns } from "./StoreLocale.vue?vue&type=template&id=678906b7&"
import script from "./StoreLocale.vue?vue&type=script&lang=ts&"
export * from "./StoreLocale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports